import Block from './Block'
import store from '../store'
import gsap from 'gsap'
import ScrollTrigger from "gsap/ScrollTrigger"

gsap.registerPlugin(ScrollTrigger);

export default class ScrollingCovers extends Block {
  onEnterCompleted() {
    super.onEnterCompleted()
    this.playing = false

    this.resize();
    this.observer();
    this.galleryOnScroll();
  }

  bindMethods() {
    super.bindMethods()

    this.onPlayClick = this.onPlayClick.bind(this)
    this.onVideoClick = this.onVideoClick.bind(this)
  }

  getElems() {
    super.getElems()

    this.video = this.el.querySelector('.b-scrolling-covers__video')
    this.player = this.el.querySelector('.b-scrolling-covers__play')
    this.galleries = this.el.querySelectorAll('.b-scrolling-covers__gallery .gallery-col')
  }

  events() {
    super.events()

    this.player && this.player.addEventListener('click', this.onPlayClick)
    this.video && this.video.addEventListener('click', this.onVideoClick)
  }

  observer() {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(() => {
        if (this.playing) {
          store.menu.unlock()
          this.pauseVideo()
        }
      })
    })

    observer.observe(this.el)
  }

  playVideo() {
    this.video.play()
    this.playing = true
    this.el.classList.add('active')
  }

  pauseVideo() {
    this.video.pause()
    this.playing = false
    this.el.classList.remove('active')
  }

  onVideoClick() {
    this.pauseVideo()
    store.menu.unlock()
  }

  onPlayClick() {
    if (store.isMobile) this.playVideo()
    else {
      store.menu.lock(true)
      store.smoothScroll.scrollTo(this.top, {
        callback: () => this.playVideo()
      })
    }
  }

  galleryOnScroll() {
    this.galleries.forEach((gallery, index) => {
      let transitionValue = "-=15%";

      if (index === 1) {
        transitionValue = "+=15%";
        gsap.set(gallery, {
          y: "-15%"
        });
      }

      if (index === 2) {
        transitionValue = "-=7.5%";
      }


      gsap.to(gallery, {
        y: transitionValue,
        scrollTrigger: {
          trigger: this.el,
          start: "top bottom",
          end: "bottom top",
          scrub: 0.2,
          scroller: store.scrollContainer
        }
      });
    });
  }

  resize() {
    this.top = this.el.getBoundingClientRect().top
  }
}
